import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser, faMapMarkerAlt, faEnvelope, faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook, faInstagram, faLinkedin, faGithub,
} from "@fortawesome/free-brands-svg-icons";
import { useLanguage } from "./LanguageContext";
import "./Contact.css";

const socials = [
  { icon: faFacebook,  label: "Facebook",  href: "https://www.facebook.com/hoope1998",              color: "#1877f2" },
  { icon: faInstagram, label: "Instagram", href: "https://www.instagram.com/abdalwahabhussien",      color: "#e1306c" },
  { icon: faLinkedin,  label: "LinkedIn",  href: "https://www.linkedin.com/in/alfaghiri/",           color: "#0077b5" },
  { icon: faGithub,    label: "GitHub",    href: "https://github.com/Alfaghiri",                     color: "#e6edf3" },
];

const infoItems = [
  { icon: faUser,          label: "Name",      value: "Abdul Wahhab Alfaghiri Al Anzi" },
  { icon: faMapMarkerAlt,  label: "Adresse",   value: "5400 Hallein, Österreich"       },
  { icon: faEnvelope,      label: "E-Mail",    value: "anzi511@gmail.com",  href: "mailto:anzi511@gmail.com" },
];

const Contact = () => {
  const { t } = useLanguage();

  return (
    <div className="ct-page">

      {/* ── HERO BLOCK ── */}
      <div className="ct-hero">
        <div className="ct-avatar-wrap">
          <img src="myphoto.svg" alt="Avatar" className="ct-avatar" />
          <div className="ct-avatar-ring" />
          <div className="ct-avatar-glow" />
        </div>

        <div className="ct-hero-text">
          <span className="ct-badge">Kontakt</span>
          <h1 className="ct-name">Abdul Wahhab<br />Alfaghiri Al Anzi</h1>
          <p className="ct-subtitle">{t.contact.subtitle}</p>
        </div>
      </div>

      {/* ── INFO CARDS ── */}
      <div className="ct-info-grid">
        {infoItems.map((item, i) => (
          item.href
            ? (
              <a key={i} href={item.href} className="ct-info-card ct-info-card--link">
                <div className="ct-info-icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
                <div className="ct-info-body">
                  <span className="ct-info-label">{item.label}</span>
                  <span className="ct-info-value">{item.value}</span>
                </div>
              </a>
            ) : (
              <div key={i} className="ct-info-card">
                <div className="ct-info-icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
                <div className="ct-info-body">
                  <span className="ct-info-label">{item.label}</span>
                  <span className="ct-info-value">{item.value}</span>
                </div>
              </div>
            )
        ))}
      </div>

      {/* ── DIVIDER ── */}
      <div className="ct-divider">
        <div className="ct-divider-line" />
        <span className="ct-divider-label">{t.contact.socialMedia}</span>
        <div className="ct-divider-line" />
      </div>

      {/* ── SOCIAL GRID ── */}
      <div className="ct-social-grid">
        {socials.map((s, i) => (
          <a
            key={i}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            className="ct-social-card"
            style={{ "--brand": s.color }}
          >
            <div className="ct-social-icon">
              <FontAwesomeIcon icon={s.icon} />
            </div>
            <span className="ct-social-label">{s.label}</span>
            <div className="ct-social-arrow">→</div>
          </a>
        ))}
      </div>

    </div>
  );
};

export default Contact;
